import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import useAgencyPortal from '@hooks/useAgencyPortal'
import useAgencyPortals from '@hooks/useAgencyPortals'

import AgencyPortalListItem from './AgencyPortalListItem'

const AgencyPortals = (props) => {
  const { agencyId } = props

  const agencyPortalsPayload = useAgencyPortals({
    filters: { agency_id: agencyId },
    performHttpRequests: !!agencyId,
    requestOptions: {
      include_agency_portal_auth_token: true,
      include_agency_portal_portal: true,
    },
  })

  const {
    assignedPortalIds,
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredAgencyPortals,
    filteredAgencyPortalsCount,
    hasFilteredAgencyPortals,
    loading,
  } = agencyPortalsPayload

  const agencyPortalPayload = useAgencyPortal({ agency_id: agencyId })
  const {
    callbacks: {
      createOrEditAgencyPortal,
    },
  } = agencyPortalPayload

  return (
    <DashboardModule title="Portals" loading={loading}>
      <Box flexDirection="column">
        {!loading && !hasFilteredAgencyPortals && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Portals present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please assign a Portal
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredAgencyPortals && (
          <DashboardModule.ScrollableSection>
            {filteredAgencyPortals.map(agencyPortal => (
              <AgencyPortalListItem
                assignedPortalIds={assignedPortalIds}
                agencyPortal={agencyPortal}
                key={agencyPortal.id}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredAgencyPortalsCount}
          loading={loading}
        >
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => createOrEditAgencyPortal({ assignedPortalIds })}
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Portal
          </Button>
        </DashboardModule.LoadMoreFooter>
      </Box>
    </DashboardModule>
  )
}

AgencyPortals.propTypes = {
  agencyId: PropTypes.number.isRequired,
}

export default AgencyPortals
